import React from "react";
import { ErrorMessage, Field } from "formik";
import _ from "lodash";
import { empty } from "../../Utilities/utils";

export default function InputFieldChange({
  name,
  placeholder,
  icon,
  id,
  type,
  height,
  width = "100%",
  labelTitle,
  fontSize = 14,
  isDisabled = false,
  as,
  rows,
  cols,
  required = false,
  ...others
}) {
  return (
    <>
      <div
        className="p-inputgroup mt-30"
        style={{ display: "flex", flexDirection: "column" }}
      >
        {!empty(labelTitle) && (
          <label htmlFor={id}>
            {labelTitle} {required ? <span className="required">*</span> : ""}
          </label>
        )}
        <div style={{ display: "flex", flexDirection: "row", marginTop: 5 }}>
          {icon && (
            <span className="p-inputgroup-addon">
              <i className={"pi pi-" + icon}></i>
            </span>
          )}
          <Field
            id={id}
            as={as}
            name={name}
            rows={rows}
            cols={cols}
            placeholder={placeholder}
            type={type}
            disabled={isDisabled}
            style={{
              width,
              border: "1px solid #f1f1f1",
              padding: "10px",
              height,
              fontSize,
              cursor: isDisabled ? "not-allowed" : "text",
            }}
            {...others}
          />
        </div>
        <ErrorMessage
          name={name}
          component="div"
          style={{
            marginTop: 7,
            fontSize: 14,
            fontStyle: "italic",
            color: "#ce1616",
          }}
        />
      </div>
    </>
  );
}
